
import Vue from 'vue';
import { Mixin } from 'vue-mixin-decorator';

@Mixin
export default class DesignPathCreator extends Vue {
  designPathCreate = (target: string): string => {
    const path = `${process.env.VUE_APP_DESIGN_RESOURCE_BASE}${target}`;
    return path;
  };
}
